type CountryCode = string;
type LanguageCode = string;

export const countryToLanguage = new Map<CountryCode, LanguageCode>([
    ['US', 'en'],
    ['CA', 'en-CA'],
    ['AU', 'en'],
    ['NZ', 'en'],
    ['GB', 'en'],
    ['FR', 'fr'],
    ['DE', 'de'],
    ['ES', 'es'],
    ['IT', 'it'],
    ['JP', 'ja'],
    ['CN', 'zh'],
    ['RU', 'ru'],
    ['PT', 'pt'],
    ['BR', 'pt-BR'],
    ['NL', 'nl'],
    ['SE', 'sv'],
    ['NO', 'no'],
    ['DK', 'da'],
    ['FI', 'fi'],
    ['PL', 'pl'],
    ['TR', 'tr'],
    ['KR', 'ko']
]);
